import React from "react";
import dayjs from "dayjs";

import { MessageType } from "./Message";

function EmojiMessage(props) {
  // const showImageInNewTab = () => {
  //   let imageLink = props.message.message.text;
  //   if (!imageLink) {
  //     return;
  //   }
  //   window.open(imageLink, "_blank");
  // };

  const showMessageTime = () => {
    return props.message.type !== MessageType.info;
  };

  const messageTimeClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-time-sent";
      case MessageType.received:
        return "s360-message-time-received";
      case MessageType.info:
        return "s360-message-time-info";
      default:
        return "";
    }
  };

  const messageBoxClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-box-sent";
      case MessageType.received:
        return "s360-message-box-received";
      case MessageType.info:
        return "s360-message-box-info";
      default:
        return "";
    }
  };

  const messageContainerClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-cotainer-sent";
      case MessageType.received:
        return "s360-message-cotainer-received";
      case MessageType.info:
        return "s360-message-cotainer-info";
      default:
        return "";
    }
  };

  const messageBoxStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.sent:
        return {
          fontSize: "50px",
          ...config?.customDesign?.emojiMessageBoxReceiver
        };
      case MessageType.received:
        return {
          background: "#FFFFFF",
          ...config?.customDesign?.emojiMessageBoxSender
        };
      default:
        return {};
    }
  };

  const messageTimeStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.received:
      case MessageType.sent:
      case MessageType.info:
        return config?.customDesign?.emojiMessageTime;
      default:
        return {};
    }
  };

  return (
    <div className={messageContainerClassName()}>
      <div
        className={messageBoxClassName()}
        style={messageBoxStyle()}
      >
        {props.message.message.text}
      </div>
      <div style={{ display: "flex", alignItems: "center", marginRight: 7 }}>
        {showMessageTime() && (
          <div
            className={messageTimeClassName()}
            style={messageTimeStyle()}
          >
            {dayjs
              .unix(
                Math.trunc(
                  this?.props?.message?.message?.sentTimestamp / 1000
                )
              )
              .format("DD MMM h:mm a")}
          </div>
        )}

        {/* <Retry {...props} /> */}
      </div>
    </div>
  );
}

export default EmojiMessage;
